<template>
  <v-autocomplete
    v-bind="$attrs"
    v-on="$listeners"
    :items="items"
    filled
    dense
    :value="iValue"
  ></v-autocomplete>
</template>

<script>
  import RefreshOnDemand from '@/components/codelist/mixins/RefreshOnDemand'
  import SiteTenantService from '@/services/site-tenant'

  export default {
    name: 'TenantSelect',
    mixins: [
      RefreshOnDemand,
    ],
    props: {
      site: {
        default: undefined,
      },
    },
    computed: {
      key () {
        return 'tenant_select'
      },
    },
    methods: {
      fetchData () {
        const ts = new SiteTenantService(this.site.id)
        ts.getForSelect().then((response) => {
          this.$store.commit('codeList/updateCache', { key: this.key, value: response.data.data })
        })
      },
    },
  }
</script>

<style scoped>

</style>
